import React, { useEffect, ReactElement } from "react";

import apiRequest from "../../apis/request";

import { useSelector } from "react-redux";

let intervalRef = null;

export default (): ReactElement => {
  const { track } = useSelector(({ track }) => ({
    track,
  }));
  useEffect(() => {
    if (!track.docId) return;

    const currentSession = track?.sessions?.find((d) => d.isActive) || {
      sessionId: "",
    };
    apiRequest("POST", "/a/presence", [], {
      trackId: track.docId,
      sessionId: currentSession.sessionId,
    });
    intervalRef = setInterval(() => {
      apiRequest("POST", "/a/presence", [], {
        trackId: track.docId,
        sessionId: currentSession.sessionId,
      });
    }, 60000);

    return () => {
      clearInterval(intervalRef);
    };
  }, [track]);

  return <></>;
};
